module.exports = __webpack_public_path__ + "img/Alters_und_Ehrengruppe.72300f30.svg";